import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { toast } from "sonner";

const inputCls = "w-full px-4 py-3 border border-[var(--line)] focus:border-[var(--accent)] outline-none text-sm";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" subtitle="Choose a new password.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <input data-testid="reset-password" type="password" required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
        <input data-testid="reset-confirm" type="password" required placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
        {error && <p className="text-sm text-[var(--destructive,#D50000)]" data-testid="reset-error">{error}</p>}
        <button disabled={loading} data-testid="reset-submit" className="w-full bg-[var(--accent)] text-white font-semibold py-3.5 hover:bg-[var(--accent-hover)] disabled:opacity-60">{loading ? "Updating…" : "Update password"}</button>
      </form>
      <p className="mt-5 text-sm text-center"><Link to="/login" className="text-[var(--ink-2)] hover:text-[var(--ink)]">Back to login</Link></p>
    </AuthShell>
  );
}
